import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastTestsHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

// The tests layout above renders the handoff for this address itself; this route only lets the
// address match the layout rather than the embedded app's catch-all.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/tests/$actionId',
)({
  component: JourneysBroadcastTestsHandoff,
});
